import React from "react";
import PropTypes from "prop-types";

// styles
import { HistoryStyled } from "./styles.js";

// components
import SideBarSection from "../SideBarSection";
import HistoryList from "./HistoryList";

// QueueContext
import { useQueueContext } from "frontend/components/fort/mod/core/Layouts/QueueLayout";

export const History = ({ children }) => {
    // state/context
    const {
        uploadTypeTitle,
        showHistory,
        state: { singleUploadSelected }
    } = useQueueContext();

    if (!showHistory || !singleUploadSelected) return null;

    // Upload
    const { history } = singleUploadSelected;
    if (!history) return null;

    return (
        <SideBarSection title={`${uploadTypeTitle} History`}>
            <HistoryStyled>
                <HistoryList items={history} />
                {children}
            </HistoryStyled>
        </SideBarSection>
    );
};

export default History;

// prop-types
History.propTypes = {
    children: PropTypes.any
};
